import React, { useState, useEffect } from "react";
import axios from "axios";
import { CRICKET_API_URL } from "../../config";

const CreateTemplate = () => {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [publishing, setPublishing] = useState(false);
    const [activeMargin, setActiveMargin] = useState(null);
    const [showModal, setShowModal] = useState(false); // Modal control karne ke liye

    const [form, setForm] = useState({
        matchId: "",
        matchTitle: "",
        name: "Mega Contest",
        type: "mega", // mega, h2h, small, winner_takes_all
        entryFee: "",
        totalSpots: "",
        prizePool: "",
        autoClone: true,
        maxTeamsPerUser: 11,
    });

    const resetForm = () => {
        setForm({
            matchId: "",
            matchTitle: "",
            name: "Mega Contest",
            type: "mega",
            entryFee: "",
            totalSpots: "",
            prizePool: "",
            autoClone: true,
            maxTeamsPerUser: 11,
        });
        setPrizeBreakup([]);
        setActiveMargin(null);
        setShowModal(false); // Modal band karne ke liye
    };

    const [prizeBreakup, setPrizeBreakup] = useState([]);

    useEffect(() => { fetchMatches(); }, []);

    const fetchMatches = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${CRICKET_API_URL}/api/cricket/matches/upcoming`);
            setMatches(res.data || []);
        } catch (err) { console.error(err); }
        finally { setTimeout(() => setLoading(false), 800); }
    };

    // --- 🏆 PROFESSIONAL PRIZE ALGORITHM ---
    const generateProfessionalBreakup = (type, spots, pool, entry) => {
        let breakup = [];
        const s = Number(spots);
        const p = Number(pool);
        const e = Number(entry);

        if (type === 'h2h' || s <= 4) {
            breakup.push({ rankStart: 1, rankEnd: 1, prizeAmount: p });
        }
        else if (type === 'small' && s <= 11) {
            breakup.push({ rankStart: 1, rankEnd: 1, prizeAmount: Math.floor(p * 0.7) });
            breakup.push({ rankStart: 2, rankEnd: 2, prizeAmount: Math.floor(p * 0.3) });
        }
        else {
            // Mega & Winner Takes All Logic (Scaling)
            const totalWinners = Math.floor(s * 0.6);
            const bottomWinnersLimit = Math.floor(s * 0.2); // Last 20% spots
            // let remainingPool = p;

            // 1. Top 3 Ranks (Fixed high %)
            const top3 = [
                { r: 1, p: 0.20 }, // 20%
                { r: 2, p: 0.10 }, // 10%
                { r: 3, p: 0.05 }  // 5%
            ];

            top3.forEach(item => {
                const amt = Math.floor(p * item.p);
                breakup.push({ rankStart: item.r, rankEnd: item.r, prizeAmount: amt });
                // remainingPool -= amt;
            });

            // 2. Dynamic Slabs (4-10, 11-50, 51-200...)
            const slabs = [
                { start: 4, end: 10, poolShare: 0.08 },
                { start: 11, end: 50, poolShare: 0.10 },
                { start: 51, end: 200, poolShare: 0.12 },
                { start: 201, end: 500, poolShare: 0.10 },
                { start: 501, end: 1000, poolShare: 0.10 }
            ];

            let lastRankAdded = 3;
            slabs.forEach(slab => {
                if (totalWinners > slab.start) {
                    const actualEnd = Math.min(slab.end, totalWinners - bottomWinnersLimit);
                    if (actualEnd >= slab.start) {
                        const slabAmt = Math.floor((p * slab.poolShare) / (actualEnd - slab.start + 1));
                        breakup.push({ rankStart: slab.start, rankEnd: actualEnd, prizeAmount: Math.max(slabAmt, e + 10) });
                        // remainingPool -= (slabAmt * (actualEnd - slab.start + 1));
                        lastRankAdded = actualEnd;
                    }
                }
            });

            // 3. Bottom Winners (Entry + 1 Rule)
            if (totalWinners > lastRankAdded) {
                const bottomStart = lastRankAdded + 1;
                const bottomEnd = totalWinners;
                const bottomAmt = e + 1;
                breakup.push({ rankStart: bottomStart, rankEnd: bottomEnd, prizeAmount: bottomAmt });
            }
        }
        setPrizeBreakup(breakup);
    };

    const handleMarginApply = (percent) => {
        const collection = (Number(form.entryFee) || 0) * (Number(form.totalSpots) || 0);
        if (collection <= 0) return alert("Entry Fee aur Spots bhariye!");

        const prizePool = Math.floor(collection - (collection * percent / 100));
        setForm(prev => ({ ...prev, prizePool }));
        setActiveMargin(percent);

        generateProfessionalBreakup(form.type, form.totalSpots, prizePool, form.entryFee);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Validation: Mega ya Winner Takes All ke liye Match select hona chahiye
        if ((form.type === 'mega' || form.type === 'winner_takes_all') && !form.matchId) {
            return alert("Bhai, pehle Match toh select kar lo!");
        }

        setPublishing(true);

        // 🚀 2. DEFINE PAYLOAD (Ye missing tha)
        const payload = {
            ...form,
            entryFee: Number(form.entryFee),
            totalSpots: Number(form.totalSpots),
            prizePool: Number(form.prizePool),
            prizeBreakup: prizeBreakup.map(p => ({
                rankStart: Number(p.rankStart),
                rankEnd: Number(p.rankEnd),
                prizeAmount: Number(p.prizeAmount)
            }))
        };

        // 3. Determine Endpoint
        const endpoint = (form.type === 'mega' || form.type === 'winner_takes_all')
            ? '/api/admin/contests/create'
            : '/api/admin/templates/create';

        try {
            const token = localStorage.getItem("token");
            await axios.post(`${CRICKET_API_URL}${endpoint}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // ✅ Success Modal dikhao (Alert ki jagah)
            setShowModal(true);

        } catch (err) {
            console.error("Save Error:", err);
            alert("❌ Error: " + (err.response?.data?.message || "Server Error"));
        } finally {
            setPublishing(false);
        }
    };

    const collection = (Number(form.entryFee) || 0) * (Number(form.totalSpots) || 0);
    const profit = collection - (Number(form.prizePool) || 0);
    const margin = collection > 0 ? ((profit / collection) * 100).toFixed(1) : 0;

    return (
        <div className="container-fluid py-4 bg-light min-vh-100">
            <div className="d-flex justify-content-between align-items-center mb-4 px-3">
                <h2 className="fw-bold">Contest Manager <span className="text-danger">Pro</span></h2>
                <button onClick={fetchMatches} className="btn btn-white shadow-sm border rounded-pill px-4">
                    {loading ? "Loading..." : "Refresh Matches"}
                </button>
            </div>

            <div className="row g-4">
                <div className="col-lg-8">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                        <div className="p-3 text-white" style={{ background: "#4A0000" }}>
                            <h6 className="mb-0 fw-bold">Configure Contest</h6>
                        </div>

                        <div className="card-body p-4 bg-white">
                            {/* MATCH SELECTOR */}
                            <div className="mb-4">
                                <label className="form-label small fw-bold text-muted">TARGET MATCH</label>
                                <select className="form-select border-0 bg-light py-3 rounded-3 fw-bold"
                                    onChange={(e) => setForm({ ...form, matchId: e.target.value })}>
                                    <option value="">-- Choose Match (Required for Mega/Winner) --</option>
                                    {matches.map(m => <option key={m.id || m.matchId} value={m.id || m.matchId}>{m.name}</option>)}
                                </select>
                            </div>

                            {/* CATEGORY */}
                            <div className="row g-2 mb-4">
                                {[
                                    { id: 'mega', label: 'Mega GL', icon: 'bi-trophy' },
                                    { id: 'h2h', label: 'H2H', icon: 'bi-people' },
                                    { id: 'small', label: 'Small League', icon: 'bi-person-plus' },
                                    { id: 'winner_takes_all', label: 'Winner Takes All', icon: 'bi-lightning-fill' }
                                ].map(cat => (
                                    <div key={cat.id} className="col-3">
                                        <div onClick={() => setForm({ ...form, type: cat.id })}
                                            className={`p-3 text-center border rounded-4 cursor-pointer transition-all ${form.type === cat.id ? 'bg-dark text-white' : 'bg-white'}`}>
                                            <i className={`bi ${cat.icon} fs-4 mb-1 d-block`}></i>
                                            <span className="small fw-bold d-block">{cat.label}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* INPUTS */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-4">
                                    <label className="small fw-bold">Entry Fee (₹)</label>
                                    <input type="number" className="form-control bg-light border-0" value={form.entryFee} onChange={(e) => setForm({ ...form, entryFee: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="small fw-bold">Total Spots</label>
                                    <input type="number" className="form-control bg-light border-0" value={form.totalSpots} onChange={(e) => setForm({ ...form, totalSpots: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="small fw-bold">Prize Pool (₹)</label>
                                    <input type="number" className="form-control bg-light border-0" value={form.prizePool} readOnly />
                                </div>
                            </div>

                            {/* BREAKUP SECTION */}
                            <div className="border-top pt-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="fw-bold mb-0">RANK WISE BREAKUP (60% Winners)</h6>
                                    <button type="button" className="btn btn-sm btn-dark" onClick={() => generateProfessionalBreakup(form.type, form.totalSpots, form.prizePool, form.entryFee)}>🪄 Auto-Fill (Smart)</button>
                                </div>
                                {prizeBreakup.map((p, idx) => (
                                    <div key={idx} className="row g-2 mb-2">
                                        <div className="col-3"><input type="number" className="form-control form-control-sm" value={p.rankStart} readOnly /></div>
                                        <div className="col-1 text-center">-</div>
                                        <div className="col-3"><input type="number" className="form-control form-control-sm" value={p.rankEnd} readOnly /></div>
                                        <div className="col-5"><input type="number" className="form-control form-control-sm bg-light fw-bold" value={p.prizeAmount} onChange={(e) => {
                                            const newB = [...prizeBreakup]; newB[idx].prizeAmount = e.target.value; setPrizeBreakup(newB);
                                        }} /></div>
                                    </div>
                                ))}
                            </div>

                            <button onClick={handleSubmit} className="btn btn-dark w-100 py-3 rounded-4 fw-bold mt-4 shadow-lg" disabled={publishing}>
                                {publishing ? "Launching..." : `Launch ${form.type.toUpperCase()}`}
                            </button>
                        </div>
                    </div>
                </div>

                {/* SIMULATOR */}
                <div className="col-lg-4">
                    <div className="sticky-top" style={{ top: '20px' }}>
                        <div className="card border-0 shadow-sm rounded-4 bg-white p-4 text-center mb-4">
                            <div className="badge bg-light text-dark border px-3 py-2 rounded-pill mb-3 fw-bold">PROFIT SIMULATOR</div>
                            <h1 className={`display-5 fw-bold mb-0 ${profit >= 0 ? 'text-success' : 'text-danger'}`}>₹{profit.toLocaleString()}</h1>
                            <p className="text-muted fw-bold small">Margin: {margin}%</p>

                            <div className="d-flex justify-content-center gap-2 mb-4">
                                {[10, 15, 20].map(p => (
                                    <button key={p} onClick={() => handleMarginApply(p)} className={`btn btn-sm rounded-pill px-3 fw-bold ${activeMargin === p ? 'btn-dark' : 'btn-outline-dark'}`}>{p}% Margin</button>
                                ))}
                            </div>

                            <div className="bg-light p-3 rounded-4 border-dashed text-start">
                                <div className="d-flex justify-content-between mb-2 small fw-bold">
                                    <span className="text-secondary">Entry Pool</span>
                                    <span>₹{collection.toLocaleString()}</span>
                                </div>
                                <div className="d-flex justify-content-between small fw-bold">
                                    <span className="text-secondary">Prize Pool</span>
                                    <span className="text-danger">- ₹{(form.prizePool || 0).toLocaleString()}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ✨ PREMIUM SUCCESS MODAL ✨ */}
            {showModal && (
                <div className="modal-backdrop d-flex align-items-center justify-content-center"
                    style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.7)', zIndex: 1050 }}>
                    <div className="card border-0 shadow-lg text-center p-4 animate-fade-in" style={{ maxWidth: '400px', borderRadius: '25px' }}>
                        <div className="mb-3">
                            <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center shadow-lg"
                                style={{ width: '80px', height: '80px', fontSize: '40px' }}>
                                <i className="bi bi-check-lg"></i>
                            </div>
                        </div>
                        <h3 className="fw-bold text-dark">Lauched!</h3>
                        <p className="text-muted">Bhai, contest successfully live ho gaya hai. Ab agla dhamaka taiyar karo!</p>
                        <button onClick={resetForm} className="btn btn-dark w-100 py-3 rounded-pill fw-bold shadow-sm mt-3 transition-all hover-scale">
                            OK, Create Another
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CreateTemplate;